import { ReactNode, lazy, Suspense, useEffect, useState } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";

// ChatBot pulls in react-markdown + remark-gfm + Supabase fetch plumbing —
// none of it belongs in the initial critical bundle for LCP. Lazy-load the
// component and only mount it once the browser is idle (or after a short
// timeout on browsers without requestIdleCallback). This keeps TBT low and
// gets the launcher button on screen without blocking hydration of the page.
const ChatBot = lazy(() =>
  import("./ChatBot").then((m) => ({ default: m.ChatBot })),
);

export function Layout({ children }: { children: ReactNode }) {
  const [mountChat, setMountChat] = useState(false);

  useEffect(() => {
    const w = window as unknown as {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    };
    if (typeof w.requestIdleCallback === "function") {
      const id = w.requestIdleCallback(() => setMountChat(true), { timeout: 3000 });
      return () => {
        (window as unknown as { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback?.(id);
      };
    }
    const timer = window.setTimeout(() => setMountChat(true), 2500);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
      {mountChat && (
        <Suspense fallback={null}>
          <ChatBot />
        </Suspense>
      )}
    </div>
  );
}
